import { render, staticRenderFns } from "./card-fastvaluedeal-title-img.vue?vue&type=template&id=2afa38e5&scoped=true&"
import script from "./card-fastvaluedeal-title-img.vue?vue&type=script&lang=js&"
export * from "./card-fastvaluedeal-title-img.vue?vue&type=script&lang=js&"
import style0 from "./card-fastvaluedeal-title-img.vue?vue&type=style&index=0&id=2afa38e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa38e5",
  null
  
)

export default component.exports